<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="30vw"
    :value="value"
    loading 
    @click:outside="close" 
    @keydown.esc="close"
  >
    <v-toolbar color="primary" dark>
      <!-- <v-toolbar-title @click="test">Добавить виджет</v-toolbar-title> -->
      <v-toolbar-title>Добавить виджет</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-container fluid>
        <!-- Список виджетов -->
        <v-list v-if="isList">
          <v-list-item-group v-model="widgetNum" @change="toOptions">
            <v-list-item 
              v-for="widget in widgetTypes" 
              :key="`widgetList_${widget.type}`"
            >
              <!-- @click="toOptions" -->
              {{ widget.name }}
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <!-- Опции виджета -->
        <v-form ref="form" v-else>

          <v-text-field 
            label="Имя виджета" 
            v-model="name" 
          />

          <ViewSelector
            v-if="isOption('views')"
            v-model="view" 
          />
          <PeriodSelector
            v-if="isOption('period')"
            v-model="period" 
          />

          <span
            v-if="isOption('projects')"
          >
            <v-checkbox v-model="isAllProjects" label="Все мои проекты"/>
            <ProjectSelector
              v-model="projects"
              :disabled="isAllProjects"
              class="mt-n2"
            />
          </span>

          <span
            v-if="isOption('projectsSingle')"
          >
            <ProjectSelector
              v-model="projects"
              single
              class="mt-n2"
            />
          </span>

          <GroupSelector
            v-if="isOption('groups')"
            v-model="groups" 
          />

          <UserSelector
            v-if="isOption('users')"
            v-model="users"
          />

          <span v-if="isOption('campaigns')">
            <v-checkbox v-model="isAllCampaigns" label="Все мои кампании"/>
            <CampaignSelector
              v-model="campaigns"
              :disabled="isAllCampaigns"
              dont-link-to-project
              class="mt-n2"
            />
          </span>

          <span v-if="isOption('type')">
            <p>Тип</p>
            <v-radio-group
              v-model="type"
              mandatory
            >
              <v-radio
                label="Поминутно"
                value="min"
              ></v-radio>
              <v-radio
                label="Посекундно"
                value="sec"
              ></v-radio>
            </v-radio-group>
          </span>

          <v-checkbox
            v-if="isOption('only_low_sla')" 
            v-model="only_low_sla"
            label="Показывать только проекты с невыполненным сервисом или SLA"
          />
          <v-checkbox
            v-if="isOption('only_forecast')" 
            v-model="only_forecast"
            label="Показывать только прогноз"
          />

          <v-card-actions>
            <v-spacer />
            <v-btn color="warning" @click="backToList">
              <v-icon>mdi-arrow-left</v-icon>
              Назад</v-btn>
            <v-btn color="success" @click="addWidget">
              <v-icon>mdi-plus</v-icon>
              Добавить</v-btn>
          </v-card-actions>


        </v-form>
      </v-container>

    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import PeriodSelector from '~/components/partials/selectors/PeriodSelector.vue';
import ViewSelector from '~/components/partials/selectors/ViewSelector.vue';
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';
import GroupSelector from '~/components/partials/selectors/GroupSelector.vue';
import UserSelector from '~/components/partials/selectors/UserSelector.vue';
import CampaignSelector from '~/components/partials/selectors/CampaignSelector.vue';
// import CaruselButton from '~/components/partials/CaruselButton.vue';

export default {
  name: 'CreateWidget',
  components: {
    PeriodSelector,
    ViewSelector,
    ProjectSelector,
    GroupSelector,
    UserSelector,
    CampaignSelector,
    // CaruselButton,
  },
  props: {
    value: Boolean,
    position: Object,
  },
  data() {
    return {
      isList: true,
      widgetNum: -1,
      widgetTypes: [
        {type: 'TableSl', name: 'Таблица SL'},
        {type: 'EmploymentWidget', name: 'Занятость'},
        {type: 'AcceptedMissed', name: 'Принятые/Пропущенные'},
        {type: 'GroupByOperator', name: 'Вызовы по операторам'},
        {type: 'HourlyDynamics', name: 'Почасовая динамика'},
        {type: 'ExtendedCall', name: 'Информация по вызовам'},
        {type: 'OksReport', name: 'Окс отчёт'},
        {type: 'AvgAgentTime', name: 'Вызовы по дням'},
        {type: 'TransferWidget', name: 'Переведённые вызовы'},
        {type: 'ForecastCalls', name: 'Прогноз вызовов по дням'},
        {type: 'OutgoingCalls', name: 'Информация по исходящим вызовам'},
        {type: 'OutgoingByOperators', name: 'Исходящие по операторам'},
        {type: 'StatisticByOperators', name: 'Статистика по операторам'},
        {type: 'VuelinerTable', name: 'Мониторинг звонков'},
        {type: 'StatisticByQueues', name: 'Статистика по очередям'},
        {type: 'OperatorCampaignStatiscticByDays', name: 'Разбивка операторов по Кампаниям'},
        {type: 'PercentageAcceptByCampaign', name: 'Процент принятых по кампаниям'},

      ],
      widgetOptions: {
        TableSl: ['views', 'period', 'projectsSingle',],
        EmploymentWidget: ['views', 'period', 'groups',],
        AcceptedMissed: ['views', 'period', 'projects',],
        GroupByOperator: ['period', 'projects',],
        HourlyDynamics: ['views', 'period', 'projects',],
        ExtendedCall: ['views', 'period', 'projects', 'type'],
        OksReport: ['period', 'projects', 'only_low_sla'],
        AvgAgentTime: ['period', 'projects',],
        TransferWidget: ['period', 'projects',],
        ForecastCalls: ['projects', 'only_forecast'],
        OutgoingCalls: ['period', 'projects', 'type'],
        OutgoingByOperators: ['views', 'period', 'projects'],
        StatisticByOperators: ['period', 'projects'],
        VuelinerTable: ['projects'],
        StatisticByQueues: ['period', 'projects'],
        OperatorCampaignStatiscticByDays: ['period', 'users'],
        PercentageAcceptByCampaign: ['period', 'campaigns'],
      },

      formValid: false,
      name: '',
      period: '',
      isAllProjects: false,
      projects: [],
      groups: [],
      view: [],
      type: '',
      only_low_sla: false,
      only_forecast: false,
      users: [],
      campaigns: [],
      isAllCampaigns: false,

      templateWidget: {
        id: '',
        name: '',
        type: '',
        hint: '',
        views: [],
        currentView: '',
        params: {},
        position: {
          x: this.position.xW,
          y: this.position.yW,
          width: 450,
          height: 350,
          min_width: 200,
          max_width: 2000,
          min_height: 200,
          max_height: 2000,
        },
      }
    }
  },

  computed: {
    ...mapGetters({
      dashboard: 'dashboard/dashboard',
    }),

    activeType() {
      return this.widgetTypes[this.widgetNum].type
    },
  },

  watch: {
    
  },

  methods: {
    ...mapActions({
      setError: 'shared/setError',
    }),
    
    close() {
      this.$emit('input', false);
    },

    toOptions() {
      this.name = this.widgetTypes[this.widgetNum].name;
      if (this.isOption('period')) {
        this.period = 'today';
      }
      this.isList = false;
    },

    backToList() {
      this.period = '';
      this.type = '';
      this.isAllProjects = false;
      this.projects = [];
      this.campaigns = [];
      this.isAllCampaigns = false;
      this.groups = [];
      this.widgetNum = -1;
      this.isList = true;
    },

    isOption(option) {
      if (!this.widgetOptions[this.activeType]) 
        return false
      return this.widgetOptions[this.activeType].includes(option)
    },

    getHint() {
      if (this.activeType === 'EmploymentWidget') {
        return `Загрузка расчитывается как отношение времени разговора к времени работы оператора.<br> 
          Красным цветом отмечены операторы у которых загрузка менее 30% <br>
          Жёлтым цветом от 30% до 50 %<br>
          Зелёным больше 50%.`
      }
      return 'Подсказка'
    },

    addWidget() {
      if (!this.$refs.form.validate()) return

      let widget = Object.assign(this.templateWidget, {
        id: this.activeType + this.getRandomString(8),
        name: this.name,
        type: this.activeType,
        hint: this.getHint(),
        params: {},
      })

      if (this.isOption('views')) {
        widget.views = this.view
        widget.currentView = this.view[0]
      }

      if (this.isOption('period')) widget.params.period = this.period
      if (this.isOption('groups')) widget.params.groups = this.groups
      if (this.isOption('type')) widget.params.type = this.type
      if (this.isOption('only_low_sla')) widget.params.only_low_sla = this.only_low_sla
      if (this.isOption('projectsSingle')) widget.params.projectsSingle = this.projects
      if (this.isOption('only_forecast')) widget.params.only_forecast = this.only_forecast
      
      if (this.isOption('projects')) {
        if (this.isAllProjects) this.projects = []
        widget.params.projects = this.projects
        widget.params.isAllProjects = this.isAllProjects
      }
      
      if (this.isOption('campaigns')) {
        if (this.isAllCampaigns) this.campaigns = []
        widget.params.campaigns = this.campaigns
        widget.params.isAllCampaigns = this.isAllCampaigns
      }

      if (this.isOption('users')) widget.params.users = this.users

      this.dashboard.widgets.push(widget)
      this.close()
    },


    getRandomString(length) {
      let simbols = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
      let out = '';

      for (let i = 0; i < length; i++) {
        out += simbols[Math.floor(Math.random() * simbols.length)];
      }
      return out
    },

    // test() {
    //   this.setError({message: 'Что-то не так'})
    // }

  },

  mounted() {
      if (this.dashboard.widgets.length >= 40) {
        this.setError({message: "У вас максимальное количество виджетов. Прежде чем добавлять новые, удалите старые"});
        setTimeout(() => {
          this.close();
        }, 200);
      }
  }

}
</script>


<style scoped lang="scss">

</style>